module.exports = __webpack_public_path__ + "static/media/pmg_team_icon.10af1a69.svg";